export {SyntheticDisplay} from './synthetic-display';
